module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?c61b9c12f68ee1ba045a4b49dba29ca5";